// Import the controller interfaces
import * as ControllerInterfaces from '../Interfaces/ControllerInterfacesBarrel';

export default abstract class AbstractControllerFactory {
	/**
	 * Returns abstraction instance of IEligibilityMessagePriorityController.
	 * */
	public abstract getEligibilityMessagePriorityController(): ControllerInterfaces.IEligibilityMessagePriorityController;
	/**
	 * Returns abstraction instance of IAppLinkController.
	 * */
	public abstract getAppLinkController(): ControllerInterfaces.IAppLinkController;

	/**
	 * Returns abstraction instance of IAuthenticationController.
	 * */
	public abstract getAuthenticationController(): ControllerInterfaces.IAuthenticationController;

	/**
	 * Returns abstraction instance of IClaimsController.
	 * */
	public abstract getClaimsController(): ControllerInterfaces.IClaimsController;

	/**
	 * Returns abstraction instance of IDocumentController.
	 * */
	public abstract getDocumentController(): ControllerInterfaces.IDocumentController;

	/**
	 * Returns abtraction instance of IEndorsementController. 
	 **/
	public abstract getEndorsementController(): ControllerInterfaces.IEndorsementController;

	/**
	 * Returns abtraction instance of IEndorsementMortgageeController. 
	 **/
	public abstract getEndorsementMortgageeController(): ControllerInterfaces.IEndorsementMortgageeController;

	/**
	 * Returns abtraction instance of IEndorsementPolicyEntityController. 
	 **/
	public abstract getEndorsementPolicyEntityController(): ControllerInterfaces.IEndorsementPolicyEntityController;

	/**
	 * Returns abraction instance of IEndorsementValidationController. 
	 **/
	public abstract getEndorsementValidationController(): ControllerInterfaces.IEndorsementValidationController;

	/**
	 * Returns abstraction instance of IIdentityController.
	 * */
	public abstract getIdentityController(): ControllerInterfaces.IIdentityController;

	/**
	 * Returns abstraction instance of IMinCostPerSquareFootController.
	 * */
	public abstract getMinCostPerSquareFootController(): ControllerInterfaces.IMinCostPerSquareFootController;

	/**
	 * Returns abstraction instance of IMinCostPerSquareFootLookupController.
	 * */
	public abstract getMinCostPerSquareFootLookupController(): ControllerInterfaces.IMinCostPerSquareFootLookupController;

	/**
	 * Returns abstraction instance of IMinCostPerSquareFootVersionController.
	 * */
	public abstract getMinCostPerSquareFootVersionController(): ControllerInterfaces.IMinCostPerSquareFootVersionController;

	/**
	 * Returns abstraction instance of INewBusinessApplicationController.
	 * */
	public abstract getNewBusinessApplicationController(): ControllerInterfaces.INewBusinessApplicationController;
	/**
	 * Returns abstraction instance of IPolicyController.
	 * */
	public abstract getPolicyController(): ControllerInterfaces.IPolicyController;

	/**
	 * Returns abstraction instance of IPolicyNoteController.
	 * */
	public abstract getPolicyNoteController(): ControllerInterfaces.IPolicyNoteController;

	/**
	 * Returns abstraction instance of IProductController.
	 * */
	public abstract getProductController(): ControllerInterfaces.IProductController;

	/**
	 * Returns abstraction instance of IPropertyController.
	 * */
	public abstract getPropertyController(): ControllerInterfaces.IPropertyController;

	/**
	 * Returns abstraction instance of IRolesController.
	 * */
	public abstract getRolesController(): ControllerInterfaces.IRolesController;

	/**
	 * Returns abstraction instance of ISignUpController.
	 * */
	public abstract getSignupController(): ControllerInterfaces.ISignUpController;
};